import axios from 'axios'
import config from '../../config.json'

axios.defaults.baseURL = `${config.requestURL}/api`
const instance = axios.create()

export function request(method, url, data) {
  return instance({ method, url, data })
}

export function requestAuth(method, url, data, params) {
  return axios({
    method,
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token_seguridad'),
    },
    url,
    data,
    params,
    paramsSerializer: (paramsObj) => {
      const query = new URLSearchParams();

      for (const key in paramsObj) {
        const value = paramsObj[key];
        if (value === null || value === undefined) continue;

        if (Array.isArray(value)) {
          value.forEach(v => query.append(key, v));
        } else {
          query.append(key, value);
        }
      }

      return query.toString();
    }
  })
}
